

// import { useState, useEffect } from 'react';
// import { X } from 'lucide-react';
// import { useManageMenuItem } from 'features/menu/hooks/useMenus';
// import { useUploadMenuImage } from 'features/menu/hooks/useUploadMenuImage';

// const ViewMenuModal = ({ isOpen, onClose, menu }) => {

//   // -----------------------------
//   // MUTATIONS
//   // -----------------------------

//   const manageMutation = useManageMenuItem();
//   const uploadMutation = useUploadMenuImage();

//   // -----------------------------
//   // STATE
//   // -----------------------------

//   const [imageFiles, setImageFiles] = useState({});
//   const [localMenu, setLocalMenu]   = useState(menu);

//   // Tracks which item is mid-update so only its buttons show loading
//   const [pendingKey, setPendingKey] = useState(null);

//   useEffect(() => {
//     setLocalMenu(menu);
//   }, [menu]);

//   // -----------------------------
//   // CLOSE GUARD
//   // -----------------------------

//   if (!isOpen || !menu) return null;

//   // -----------------------------
//   // HANDLE ITEM UPDATE
//   //
//   // Items identified by subcategoryId (ObjectId string) + itemSlug.
//   // subcategoryId comes directly from sub.subcategoryId in the response.
//   // -----------------------------

//   const handleItemUpdate = async ({ subcategoryId, itemSlug, updates }) => {

//     const itemKey  = `${subcategoryId}__${itemSlug}`;
//     const snapshot = localMenu;

//     try {
//       setPendingKey(itemKey);

//       // -------------------------
//       // OPTIMISTIC UI UPDATE
//       // -------------------------

//       setLocalMenu((prev) => {
//         if (!prev) return prev;

//         return {
//           ...prev,
//           subcategories:
//             prev?.subcategories?.map((sub) => {

//               if (
//                 sub?.subcategoryId?.toString() !== subcategoryId?.toString()
//               ) return sub;

//               return {
//                 ...sub,
//                 items:
//                   sub?.items?.map((item) => {
//                     if (item?.slug !== itemSlug) return item;
//                     return { ...item, ...updates };
//                   }) || [],
//               };
//             }) || [],
//         };
//       });

//       // -------------------------
//       // API CALL
//       // -------------------------

//       await manageMutation.mutateAsync({
//         menuId:        localMenu?.menuId || localMenu?._id,
//         subcategoryId,
//         itemSlug,
//         ...updates,
//       });

//     } catch (error) {

//       // -------------------------
//       // ROLLBACK ON ERROR
//       // -------------------------

//       setLocalMenu(snapshot);
//       alert(error?.message || 'Failed to update item');

//     } finally {
//       setPendingKey(null);
//     }
//   };

//   // -----------------------------

//   return (
//     <div className="fixed inset-0 bg-black/50 z-50 flex justify-center items-center p-4">

//       {/* MODAL */}
//       <div className="bg-background rounded-xl w-full max-w-6xl max-h-[90vh] overflow-y-auto p-6">

//         {/* HEADER */}
//         <div className="flex justify-between items-center mb-6">
//           <h2 className="text-2xl font-bold">Menu Details</h2>
//           <button onClick={onClose} className="text-gray-400 hover:text-black">
//             <X size={20} />
//           </button>
//         </div>

//         {/* MENU COVER IMAGE                         */}
//         {/* key = signed S3 URL (transformer output) */}
//         {/* <img
//           src={localMenu?.images?.[0]?.key || localMenu?.images?.[0]?.url || '/placeholder-food.png'}
//           alt="menu"
//           className="w-full h-64 object-cover rounded-xl"
//         /> */}

//         {/* MENU INFO */}
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">

//           {/* <div className="border rounded-lg p-4">
//             <p className="text-sm text-muted-foreground">Service Type</p>
//             <p className="font-medium capitalize">{localMenu?.serviceType || '-'}</p>
//           </div> */}

//           <div className="border rounded-lg p-4">
//             <p className="text-sm text-muted-foreground">Subcategories</p>
//             <p className="font-medium">{localMenu?.totalCategories ?? 0}</p>
//           </div>

//           <div className="border rounded-lg p-4">
//             <p className="text-sm text-muted-foreground">Total Items</p>
//             <p className="font-medium">{localMenu?.totalItems ?? 0}</p>
//           </div>

//           {/* <div className="border rounded-lg p-4">
//             <p className="text-sm text-muted-foreground">Status</p>
//             <p className={localMenu?.isActive ? 'text-green-600 font-medium' : 'text-red-500 font-medium'}>
//               {localMenu?.isActive ? 'Active' : 'Inactive'}
//             </p>
//           </div> */}

//         </div>

//         {/* SUBCATEGORIES */}
//         <div className="mt-10 space-y-10">
//           {localMenu?.subcategories?.map((sub) => (
//             <div key={sub?.subcategoryId?.toString()}>

//               {/* SUBCATEGORY HEADER                              */}
//               {/* description is not returned by the API.         */}
//               {/* Show subcategoryId as a readable fallback label.*/}
//               <div className="mb-4">
//                 <h3 className="text-xl font-semibold">
//                   {sub?.subcategoryName}
//                 </h3>
//                 <p className="text-sm text-muted-foreground">
//                   {sub?.totalItems ?? 0} item{sub?.totalItems !== 1 ? 's' : ''}
//                 </p>
//               </div>

//               {/* ITEMS */}
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {sub?.items?.map((item) => {

//                   const itemSlug          = item?.slug;
//                   const itemKey           = `${sub?.subcategoryId}__${itemSlug}`;
//                   const isThisItemPending = pendingKey === itemKey;

//                   return (
//                     <div
//                       key={itemSlug || item?.name}
//                       className="border rounded-xl overflow-hidden bg-card"
//                     >

//                       {/* ITEM IMAGE                                */}
//                       {/* key = signed S3 URL (transformer output)  */}
//                       <img
//                         src={item?.images?.[0]?.key || item?.images?.[0]?.url || '/placeholder-food.png'}
//                         alt={item?.name || 'food'}
//                         className="w-full h-48 object-cover"
//                       />

//                       <div className="p-4">

//                         {/* NAME */}
//                         <h4 className="font-semibold text-lg">{item?.name}</h4>

//                         {/* DESCRIPTION */}
//                         <p className="text-sm text-muted-foreground mt-1 line-clamp-2">
//                           {item?.shortDescription}
//                         </p>

//                         {/* PRICE */}
//                         <div className="mt-3">
//                           <p className="font-medium">₹ {item?.price ?? 0}</p>
//                           {(item?.discountedPrice ?? 0) > 0 && (
//                             <div className="flex items-center gap-2 mt-0.5">
//                               <p className="text-sm text-green-600">
//                                 ₹ {item?.discountedPrice}
//                               </p>
//                               {/* discountPercentage — auto-calculated by pre('save') hook */}
//                               {(item?.discountPercentage ?? 0) > 0 && (
//                                 <span className="text-xs px-1.5 py-0.5 rounded bg-green-500/10 text-green-600">
//                                   {item.discountPercentage}% off
//                                 </span>
//                               )}
//                             </div>
//                           )}
//                         </div>

//                         {/* FOOD TYPE */}
//                         <div className="mt-3">
//                           <span className="px-2 py-1 rounded-full text-xs bg-muted capitalize">
//                             {/* {item?.foodType || '-'} */}

//                             {
//   item?.foodType
//     ?.replace(/_/g, ' ')
//     .replace(/\b\w/g, char => char.toUpperCase()) || '-'
// }
//                           </span>
//                         </div>

//                         {/* FLAGS */}
//                         <div className="flex flex-wrap gap-2 mt-4">
//                           {item?.isApproved && (
//                             <span className="px-2 py-1 rounded-full text-xs bg-green-500/10 text-green-600">
//                               Approved
//                             </span>
//                           )}
//                           {item?.isPopular && (
//                             <span className="px-2 py-1 rounded-full text-xs bg-yellow-500/10 text-yellow-600">
//                               Popular
//                             </span>
//                           )}
//                           {item?.isRecommended && (
//                             <span className="px-2 py-1 rounded-full text-xs bg-blue-500/10 text-blue-600">
//                               Recommended
//                             </span>
//                           )}
//                           {item?.isTodaySpecial && (
//                             <span className="px-2 py-1 rounded-full text-xs bg-red-500/10 text-red-600">
//                               Today Special
//                             </span>
//                           )}
//                         </div>

//                         {/* AVAILABILITY */}
//                         <div className="mt-4">
//                           <span className={item?.isAvailable ? 'text-green-600 text-sm' : 'text-red-500 text-sm'}>
//                             {item?.isAvailable ? 'Available' : 'Unavailable'}
//                           </span>
//                         </div>

//                         {/* ACTIONS */}
//                         <div className="mt-5 space-y-3">

//                           {/* APPROVE / DISAPPROVE */}
//                           <button
//                             disabled={isThisItemPending}
//                             onClick={() =>
//                               handleItemUpdate({
//                                 subcategoryId: sub?.subcategoryId,
//                                 itemSlug,
//                                 updates: { isApproved: !item?.isApproved },
//                               })
//                             }
//                             className={`w-full px-3 py-2 rounded-lg text-sm text-white disabled:opacity-50 ${
//                               item?.isApproved ? 'bg-red-500' : 'bg-green-600'
//                             }`}
//                           >
//                             {isThisItemPending
//                               ? 'Updating...'
//                               : item?.isApproved
//                               ? 'Disapprove Item'
//                               : 'Approve Item'}
//                           </button>

//                           {/* ACTIVATE / DEACTIVATE */}
//                           <button
//                             disabled={isThisItemPending}
//                             onClick={() =>
//                               handleItemUpdate({
//                                 subcategoryId: sub?.subcategoryId,
//                                 itemSlug,
//                                 updates: { isAvailable: !item?.isAvailable },
//                               })
//                             }
//                             className={`w-full px-3 py-2 rounded-lg text-sm text-white disabled:opacity-50 ${
//                               item?.isAvailable ? 'bg-orange-500' : 'bg-blue-600'
//                             }`}
//                           >
//                             {isThisItemPending
//                               ? 'Updating...'
//                               : item?.isAvailable
//                               ? 'Deactivate Item'
//                               : 'Activate Item'}
//                           </button>

//                           {/* IMAGE UPLOAD */}
//                           <div className="space-y-2">
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) =>
//                                 setImageFiles((prev) => ({
//                                   ...prev,
//                                   [itemSlug]: e.target.files[0],
//                                 }))
//                               }
//                             />
//                             <button
//                               disabled={uploadMutation?.isPending || !imageFiles[itemSlug]}
//                               onClick={() =>
//                                 uploadMutation.mutate(
//                                   {
//                                     file:          imageFiles[itemSlug],
//                                     menuId:        localMenu?.menuId || localMenu?._id,
//                                     subcategoryId: sub?.subcategoryId,
//                                     itemSlug,
//                                   },
//                                   {
//                                     onSuccess: () => {
//                                       setImageFiles((prev) => {
//                                         const next = { ...prev };
//                                         delete next[itemSlug];
//                                         return next;
//                                       });
//                                     },
//                                   }
//                                 )
//                               }
//                               className="w-full px-3 py-2 rounded-lg bg-primary text-white text-sm disabled:opacity-50"
//                             >
//                               {uploadMutation?.isPending ? 'Uploading...' : 'Update Image'}
//                             </button>
//                           </div>

//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>

//             </div>
//           ))}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default ViewMenuModal;




import { useState, useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { useManageMenuItem } from 'features/menu/hooks/useMenus';
import { useUploadMenuImage } from 'features/menu/hooks/useUploadMenuImage';

const ViewMenuModal = ({ isOpen, onClose, menu }) => {

  // -----------------------------
  // MUTATIONS
  // -----------------------------

  const manageMutation = useManageMenuItem();
  const uploadMutation = useUploadMenuImage();

  // -----------------------------
  // STATE & REFS
  // -----------------------------

  const [imageFiles, setImageFiles]     = useState({});
  const [uploadingKey, setUploadingKey] = useState(null);
  const [localMenu, setLocalMenu]       = useState(menu);
  const [pendingKey, setPendingKey]     = useState(null);

  // ✅ Prevents invalidateQueries refetch from overwriting a just-patched image
  const skipMenuSyncRef = useRef(false);

  useEffect(() => {
    if (skipMenuSyncRef.current) {
      skipMenuSyncRef.current = false;
      return;
    }
    setLocalMenu(menu);
  }, [menu]);

  // -----------------------------
  // CLOSE GUARD
  // -----------------------------

  if (!isOpen || !menu) return null;

  // -----------------------------
  // HANDLE ITEM UPDATE
  // -----------------------------

  const handleItemUpdate = async ({ subcategoryId, itemSlug, updates }) => {

    const itemKey  = `${subcategoryId}__${itemSlug}`;
    const snapshot = localMenu;

    try {
      setPendingKey(itemKey);

      setLocalMenu((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          subcategories:
            prev?.subcategories?.map((sub) => {
              if (sub?.subcategoryId?.toString() !== subcategoryId?.toString())
                return sub;
              return {
                ...sub,
                items:
                  sub?.items?.map((item) => {
                    if (item?.slug !== itemSlug) return item;
                    return { ...item, ...updates };
                  }) || [],
              };
            }) || [],
        };
      });

      await manageMutation.mutateAsync({
        menuId:        localMenu?.menuId || localMenu?._id,
        subcategoryId,
        itemSlug,
        ...updates,
      });

    } catch (error) {
      setLocalMenu(snapshot);
      alert(error?.message || 'Failed to update item');
    } finally {
      setPendingKey(null);
    }
  };

  // -----------------------------
  // PATCH localMenu WITH NEW IMAGE
  // -----------------------------

  const patchItemImage = ({ subcategoryId, itemSlug, preSignedUrl }) => {
    // ✅ Block the next useEffect sync triggered by invalidateQueries
    skipMenuSyncRef.current = true;

    setLocalMenu((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        subcategories: prev.subcategories?.map((sub) => {
          if (sub?.subcategoryId?.toString() !== subcategoryId?.toString())
            return sub;
          return {
            ...sub,
            items: sub.items?.map((item) => {
              if (item?.slug !== itemSlug) return item;
              return {
                ...item,
                images: [
                  { key: preSignedUrl },
                  ...(item.images?.slice(1) ?? []),
                ],
              };
            }) ?? [],
          };
        }) ?? [],
      };
    });
  };

  // -----------------------------
  // HANDLE IMAGE UPLOAD
  // -----------------------------

  const handleImageUpload = ({ file, menuId, subcategoryId, itemSlug }) => {

    const itemKey = `${subcategoryId}__${itemSlug}`;
    setUploadingKey(itemKey);

    uploadMutation.mutate(
      { file, menuId, subcategoryId, itemSlug },
      {
        onSuccess: (uploadedData) => {
          // ✅ uploadedData is now `uploaded?.data` from mutationFn
          const preSignedUrl = uploadedData?.preSignedUrl;

          if (preSignedUrl) {
            patchItemImage({ subcategoryId, itemSlug, preSignedUrl });
          }

          setImageFiles((prev) => {
            const next = { ...prev };
            delete next[itemSlug];
            return next;
          });
        },

        onError: (error) => {
          alert(error?.message || 'Failed to upload image');
        },

        onSettled: () => {
          setUploadingKey(null);
        },
      }
    );
  };

  // -----------------------------

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex justify-center items-center p-4">

      {/* MODAL */}
      <div className="bg-background rounded-xl w-full max-w-6xl max-h-[90vh] overflow-y-auto p-6">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Menu Details</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-black">
            <X size={20} />
          </button>
        </div>

        {/* MENU INFO */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">

          <div className="border rounded-lg p-4">
            <p className="text-sm text-muted-foreground">Subcategories</p>
            <p className="font-medium">{localMenu?.totalCategories ?? 0}</p>
          </div>

          <div className="border rounded-lg p-4">
            <p className="text-sm text-muted-foreground">Total Items</p>
            <p className="font-medium">{localMenu?.totalItems ?? 0}</p>
          </div>

        </div>

        {/* SUBCATEGORIES */}
        <div className="mt-10 space-y-10">
          {localMenu?.subcategories?.map((sub) => (
            <div key={sub?.subcategoryId?.toString()}>

              {/* SUBCATEGORY HEADER */}
              <div className="mb-4">
                <h3 className="text-xl font-semibold">
                  {sub?.subcategoryName}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {sub?.totalItems ?? 0} item{sub?.totalItems !== 1 ? 's' : ''}
                </p>
              </div>

              {/* ITEMS */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {sub?.items?.map((item) => {

                  const itemSlug            = item?.slug;
                  const itemKey             = `${sub?.subcategoryId}__${itemSlug}`;
                  const isThisItemPending   = pendingKey === itemKey;
                  const isThisItemUploading = uploadingKey === itemKey;

                  return (
                    <div
                      key={itemSlug || item?.name}
                      className="border rounded-xl overflow-hidden bg-card"
                    >

                      {/* ITEM IMAGE */}
                      <img
                        src={item?.images?.[0]?.key || item?.images?.[0]?.url || '/placeholder-food.png'}
                        alt={item?.name || 'food'}
                        className="w-full h-48 object-cover"
                      />

                      <div className="p-4">

                        {/* NAME */}
                        <h4 className="font-semibold text-lg">{item?.name}</h4>

                        {/* DESCRIPTION */}
                        <p className="text-sm text-muted-foreground mt-1 line-clamp-2">
                          {item?.shortDescription}
                        </p>

                        {/* PRICE */}
                        <div className="mt-3">
                          <p className="font-medium">₹ {item?.price ?? 0}</p>
                          {(item?.discountedPrice ?? 0) > 0 && (
                            <div className="flex items-center gap-2 mt-0.5">
                              <p className="text-sm text-green-600">
                                ₹ {item?.discountedPrice}
                              </p>
                              {(item?.discountPercentage ?? 0) > 0 && (
                                <span className="text-xs px-1.5 py-0.5 rounded bg-green-500/10 text-green-600">
                                  {item.discountPercentage}% off
                                </span>
                              )}
                            </div>
                          )}
                        </div>

                        {/* FOOD TYPE */}
                        <div className="mt-3">
                          <span className="px-2 py-1 rounded-full text-xs bg-muted capitalize">
                            {item?.foodType
                              ?.replace(/_/g, ' ')
                              .replace(/\b\w/g, (char) => char.toUpperCase()) || '-'}
                          </span>
                        </div>

                        {/* FLAGS */}
                        <div className="flex flex-wrap gap-2 mt-4">
                          {item?.isApproved && (
                            <span className="px-2 py-1 rounded-full text-xs bg-green-500/10 text-green-600">
                              Approved
                            </span>
                          )}
                          {item?.isPopular && (
                            <span className="px-2 py-1 rounded-full text-xs bg-yellow-500/10 text-yellow-600">
                              Popular
                            </span>
                          )}
                          {item?.isRecommended && (
                            <span className="px-2 py-1 rounded-full text-xs bg-blue-500/10 text-blue-600">
                              Recommended
                            </span>
                          )}
                          {item?.isTodaySpecial && (
                            <span className="px-2 py-1 rounded-full text-xs bg-red-500/10 text-red-600">
                              Today Special
                            </span>
                          )}
                        </div>

                        {/* AVAILABILITY */}
                        <div className="mt-4">
                          <span className={item?.isAvailable ? 'text-green-600 text-sm' : 'text-red-500 text-sm'}>
                            {item?.isAvailable ? 'Available' : 'Unavailable'}
                          </span>
                        </div>

                        {/* ACTIONS */}
                        <div className="mt-5 space-y-3">

                          {/* APPROVE / DISAPPROVE */}
                          <button
                            disabled={isThisItemPending}
                            onClick={() =>
                              handleItemUpdate({
                                subcategoryId: sub?.subcategoryId,
                                itemSlug,
                                updates: { isApproved: !item?.isApproved },
                              })
                            }
                            className={`w-full px-3 py-2 rounded-lg text-sm text-white disabled:opacity-50 ${
                              item?.isApproved ? 'bg-red-500' : 'bg-green-600'
                            }`}
                          >
                            {isThisItemPending
                              ? 'Updating...'
                              : item?.isApproved
                              ? 'Disapprove Item'
                              : 'Approve Item'}
                          </button>

                          {/* ACTIVATE / DEACTIVATE */}
                          <button
                            disabled={isThisItemPending}
                            onClick={() =>
                              handleItemUpdate({
                                subcategoryId: sub?.subcategoryId,
                                itemSlug,
                                updates: { isAvailable: !item?.isAvailable },
                              })
                            }
                            className={`w-full px-3 py-2 rounded-lg text-sm text-white disabled:opacity-50 ${
                              item?.isAvailable ? 'bg-orange-500' : 'bg-blue-600'
                            }`}
                          >
                            {isThisItemPending
                              ? 'Updating...'
                              : item?.isAvailable
                              ? 'Deactivate Item'
                              : 'Activate Item'}
                          </button>

                          {/* IMAGE UPLOAD */}
                          <div className="space-y-2">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                setImageFiles((prev) => ({
                                  ...prev,
                                  [itemSlug]: e.target.files[0],
                                }))
                              }
                            />
                            <button
                              disabled={isThisItemUploading || !imageFiles[itemSlug]}
                              onClick={() =>
                                handleImageUpload({
                                  file:          imageFiles[itemSlug],
                                  menuId:        localMenu?.menuId || localMenu?._id,
                                  subcategoryId: sub?.subcategoryId,
                                  itemSlug,
                                })
                              }
                              className="w-full px-3 py-2 rounded-lg bg-primary text-white text-sm disabled:opacity-50"
                            >
                              {isThisItemUploading ? 'Uploading...' : 'Update Image'}
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ViewMenuModal;
